module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 73);
/******/ })
/************************************************************************/
/******/ ({

/***/ 21:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/api");

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = require("@tencent/iwan-axios-lib");

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
/* harmony import */ var _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tencent_iwan_axios_lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35);
/* harmony import */ var _tencent_iwan_axios_lib__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tencent_iwan_axios_lib__WEBPACK_IMPORTED_MODULE_1__);


/* harmony default export */ __webpack_exports__["default"] = ({
  /**
   * 用户信息
   * @param params
   * @returns {*}
   */
  getNickAndAvatar: function getNickAndAvatar(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/api/v1/getNickAndAvatar', {
      params: params
    });
  },
  /**
   * 用户安全等级
   * @param params
   * @returns {*}
   */
  keplerCheck: function keplerCheck(params) {
    return _tencent_iwan_axios_lib__WEBPACK_IMPORTED_MODULE_1__["iwanRequest"].get('/api/v1/keplerCheck', {
      params: params
    });
  },
  /**
   * 用户安全风险策略
   * @param data
   * @returns {*}
   */
  getRiskStrategy: function getRiskStrategy(data) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.post('/trpc.iwan.sale_server.SaleServer/getUserRiskStrategy', JSON.stringify(data), {
      contentType: 'application/json'
    });
  },
  /**
   * vip
   * @param params
   * @returns {*}
   */
  getVipLevel: function getVipLevel(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/api/v1/checkOpenVipFromActV1', {
      params: params
    });
  },
  /**
   * 游戏区服获取
   * @param params
   * @returns {*}
   */
  getGameZone: function getGameZone(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/api/v6/getGameZoneInfo', {
      params: params
    });
  },
  /**
   * 游戏用户玩过的区服
   * @param params
   * @returns {*}
   */
  getUserPlayZone: function getUserPlayZone(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/api/v6/getUserPlayGameZone', {
      params: params
    });
  },
  /**
   * 游戏角色获取
   * @param params
   * @returns {*}
   */
  getUserPlayRole: function getUserPlayRole(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/interface/checkapprole', {
      params: params
    });
  },
  /**
   * 礼包领取
   * @param params
   * @returns {*}
   */
  giftExchange: function giftExchange(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/newsapp/exchange', {
      params: params
    });
  },
  /**
   * 礼包一键领取
   * @param params
   * @returns {*}
   */
  giftAllExchange: function giftAllExchange(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/api/v5/exchange', {
      params: params
    });
  },
  /**
   * 上报手机号
   * @param params
   * @returns {*}
   */
  submitPhone: function submitPhone(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/mobilev3/bookingPhone', {
      params: params
    });
  },
  /**
   * 游戏预约自动下载
   * @param params
   * @returns {*}
   */
  bookAutoDownload: function bookAutoDownload(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/userOrder/setGameBookAutoDownload', {
      params: params
    });
  },
  /**
   * 判断是否开启push提醒
   */
  getPushStatus: function getPushStatus(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/autopush/getPushStatus', {
      params: params
    });
  },
  /**
   * 设置提醒
   */
  setPushStatus: function setPushStatus(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/autopush/modPushStatus', {
      params: params
    });
  },
  /**
   * 获取游戏下载信息
   */
  getMutiGameInfo: function getMutiGameInfo(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/mobilev8/getMutiGameInfo', {
      params: params
    });
  },
  /**
   * 获取游戏下载推荐列表
   */
  downLoadAds: function downLoadAds(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/mobilev3/downLoadingAds', {
      params: params
    });
  },
  /**
   * 获取服务器时间
   */
  getServerTime: function getServerTime() {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/api/v1/time');
  },
  /**
   * 游戏内解析登录态
   */
  loginParams: function loginParams(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/consult/getUrl', {
      params: params,
      unique: true
    });
  },
  /**
   * 关注视频号
   */
  subscribeAdaptor: function subscribeAdaptor(params) {
    return _tencent_txv_athena_api_base__WEBPACK_IMPORTED_MODULE_0___default.a.get('/trpc.iwan.iwan_public_cgi.PublicCgi/SubscribeAdaptor', {
      params: params
    });
  },
  /**
   * 游戏内解析登录态v2
   */
  msdkLoginParams: function msdkLoginParams(data) {
    return _tencent_iwan_axios_lib__WEBPACK_IMPORTED_MODULE_1__["iwanRequest"].post('/ingame/login', data, {
      unique: true
    });
  }
});

/***/ })

/******/ })["default"];